module.exports = __webpack_public_path__ + "img/speaker.c8d336ef.png";